import { Injectable } from '@angular/core';
import { DataService } from '../shared-module/services/data.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PolicyAssignService {
    configuration = {
        API_ENDPOINT : environment.apiUrl,
    };

    constructor(
        private dataService: DataService ) {
    }

    public getDepartmentsList(body) {
        return this.dataService.postData(
            this.configuration.API_ENDPOINT + 'cdirpm/rest/cdirpmService/getdept', body
        );
    }

    public getUsersList(body) {
        return this.dataService.postData(
            this.configuration.API_ENDPOINT + 'cdirpm/rest/cdirpmService/getusers', body
        );
    }
    public assignPolicy(body) {
        return this.dataService.postData(
            this.configuration.API_ENDPOINT + 'cdirpm/rest/cdirpmService/assignpolicy', body
        );
    }
    public deleteUser(body) {
        return this.dataService.postData(
            this.configuration.API_ENDPOINT + 'cdirpm/rest/cdirpmService/deleteusers', body
        );
    }

}
